export default __webpack_public_path__ + "static/media/concussion.a8eebba3.png";